module.exports = __webpack_public_path__ + "static/media/IMG_4033 laundry top and sink.161f5bff.JPG";